import { api } from '@/services/api';
import type { DeviceNavigationResponse } from '../types';

export const devicesNavigationApi = {
  async get(): Promise<DeviceNavigationResponse> {
    const { data } = await api.get<DeviceNavigationResponse>('/navigation/devices');
    return data;
  },
};

